module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0081.jpg?v=4650e5a3";